import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CallWaiterService } from '@core';
import { CallWaiterIndicatorComponent } from '@app/components/call-waiter-indicator/call-waiter-indicator.component';
import { map } from 'rxjs/operators';
import { shareReplay } from 'rxjs';

@Component({
  selector: 'app-button-call-waiter-bill',
  templateUrl: './button-call-waiter-bill.component.html',
  styleUrl: './button-call-waiter-bill.component.scss',
  imports: [
    CallWaiterIndicatorComponent,
  ],
  host: {
    'role': 'button',
    '[class.disabled]': 'disabled()',
    '[class.active]': 'callWaiterRequestBill()',
    '[class.fr]': 'currentLanguage() === "fr-CA"',
    '(click)': 'onClick($event)',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonCallWaiterBillComponent {

  private readonly translate = inject(TranslateService);
  private readonly callWaiterService = inject(CallWaiterService);

  public readonly currentLanguage = toSignal(this.translate.onLangChange.pipe(
    map((event) => event.lang),
    shareReplay(1),
  ), { initialValue: this.translate.getCurrentLang() });

  public readonly callWaiterMain = toSignal(this.callWaiterService.mainStatus$, {
    initialValue: true,
  });

  public readonly callWaiterRequestBill = toSignal(this.callWaiterService.secondaryStatus$, {
    requireSync: true,
  });

  public readonly callWaiterAnotherRound = toSignal(this.callWaiterService.tertiaryStatus$, {
    requireSync: true,
  });

  public readonly disabled = computed(() => {
    return this.callWaiterMain() || this.callWaiterAnotherRound();
  });

  public onClick($event: MouseEvent): void {
    $event.preventDefault();

    if (this.disabled()) {
      return;
    }

    this.callWaiterService.setSecondary(!this.callWaiterRequestBill());
  }

}
